import React, { useEffect, useState } from "react";
import Drag from "./Drag";
import "./style.scss";

const Uploader = ({
  inputRef,
  handleFileUpload,
  handleDelete,
  uploadLoading,
  data,
  images,
  currentIndex
}) => {
  const [error, setError] = useState("");
  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (file && file.size > 50 * 1024 * 1024) {
      setError("You can not upload a file larger than 50MB.");
    } else if (file) {
      setError("");
      await handleFileUpload(file);
    }
  };

  useEffect(()=>{
    setError('')
  },[currentIndex])

  return (
    <div className="uploader__sec_new">
      {!images?.length ? <p>{data?.supportingDoc}</p> : ""}
      <>
        <Drag
          uploadLoading={uploadLoading}
          handleFileUpload={handleFileUpload}
          handleUpload={handleUpload}
          inputRef={inputRef}
          error={error}
        />
      </>
      <p style={{ fontSize: "14px" }}>
        Accepted file types: PDF, JPG, JPEG, PNG, MOV, MP4, XLS, XLSX, CSV (Max 50MB per file)
      </p>
      <div className="d-flex flex-column gap-2">
        {images?.map((v, i) => {
          return (
            <div className="down__sec">
              <div className="uploaded__file">
                <button className="filename">{v?.fileName}</button>
              </div>
              <div className="">
                <button className="delete" onClick={() => handleDelete(v)}>
                  DELETE
                </button>
              </div>
            </div>
          );
        })}
        {error ? <span style={{ color: "red" }}>{error ?? ""}</span> : ""}
        {/* {(filename && url) && (
                    <>
                        <div className="uploaded__file">
                            <button className="filename">{filename}</button>
                        </div>
                        <div className="">
                            <button className="delete" onClick={handleDelete}>
                                DELETE
                            </button>
                        </div>
                    </>
                )} */}
      </div>
    </div>
  );
};

export default Uploader;
